module.exports = __webpack_public_path__ + "static/media/f1.553cc276.png";